'use client';

import { useQuery } from '@tanstack/react-query';
import { PropsWithChildren } from 'react';

import { isStageDev } from '../../utils/common';

/**
 * @link https://www.handongryong.com/post/msw/
 */
export const LayoutMswInit = ({ children }: PropsWithChildren) => {
  const isEnvEnabled = process.env.NEXT_PUBLIC_MSW_ENABLED;
  const isMswEnabled = !!(isEnvEnabled && isStageDev);

  const { data: mswReady } = useQuery({
    queryKey: ['LayoutMswInit'],
    queryFn: async () => {
      if (!isMswEnabled) return false;

      const data = await import('../../mocks/index');
      await data.initMSW();

      // 초기화 완료 후 약간의 지연을 줍니다.
      await new Promise((resolve) => setTimeout(resolve, 1500));

      return true;
    },
    enabled: isMswEnabled,
  });

  /**
   * 상용환경이거나 NEXT_PUBLIC_MSW_ENABLED 환경변수가 꺼져 있는 경우
   */
  if (!isMswEnabled) return <>{children}</>;

  /**
   * isMswEnabled가 true 이면서 MSW 모듈 로딩이 완료되지 않은 경우
   */
  if (!mswReady) return <div>개발환경에서만 진행되는 MSW Loading...</div>;

  return <>{children}</>;
};
